import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrderContextService } from 'gung-standard';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { ShipmentPrints } from './cult-unifaun-returns.service';

export interface CultSimplifiedOrderContextStatus {
  contextId: string;
  erpOrderIds: string[];
  finalized: boolean;
  originalInput?: {
    confirmationEmails: string[];
  };
  shipmentPrints?: ShipmentPrints[];
}

@Injectable({
  providedIn: 'root'
})
export class CultOrderContextService extends OrderContextService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  getSimplifiedOrderContext(contextId: string): Observable<CultSimplifiedOrderContextStatus> {
    const headers = {
      maxAge: '-1'
    };
    return this.http.get<any>(`${this.baseUrl}/${contextId}`, { headers }).pipe(
      map(resp => {
        if (resp === null) {
          throw new Error('CONTEXT_NOT_FOUND');
        }
        return {
          contextId: resp.id,
          erpOrderIds: resp.erpOrderIds,
          finalized: !!resp.finalized,
          originalInput: {
            confirmationEmails: resp.originalInput ? resp.originalInput.confirmationEmails : null
          },
          shipmentPrints: resp.originalInput.extra.shipmentPrints ?? null
        };
      })
    );
  }
}
